export default __webpack_public_path__ + "img/newcomers.171b0980.png";